import React from "react";
import PropTypes from "prop-types";
import { Schema } from "@sparefoot/react-commons";

const FacilityWebPageSchema = ({ facilityName, canonicalUrl, baseUrl, city, stateCode }) => {
	if (!canonicalUrl || typeof canonicalUrl !== "string") return null;
	const rootUrl = baseUrl || "https://www.storage.com";
	const webPageSchema = {
		"@context": "https://schema.org",
		"@type": "WebPage",
		"@id": `${canonicalUrl}#webpage`,
		name: `${facilityName} in ${city}, ${stateCode} | Storage.com`,
		url: canonicalUrl,
		description: `Reserve a storage unit at ${facilityName} quickly and safely. See current pricing, read reviews, and book online today.`,
		isPartOf: {
			"@id": `${rootUrl}/#website`
		}
	};

	return <Schema schema={webPageSchema} />;
};

FacilityWebPageSchema.propTypes = {
	facilityName: PropTypes.string.isRequired,
	canonicalUrl: PropTypes.string.isRequired,
	baseUrl: PropTypes.string,
	city: PropTypes.string.isRequired,
	stateCode: PropTypes.string.isRequired
};

export default FacilityWebPageSchema;
